import { BoothSelectionWidget, ShopSelectionWidget } from "components/FormWidget";
const uiSchema = () => ({
  shop_id: {
    'ui:widget': ShopSelectionWidget,
  },
  base_store_code: {
    'ui:widget': BoothSelectionWidget,
  }
});

export default uiSchema;
